/* Tintselector: de bestellijst met een rij per tint.

   Wat dit bestand doet:
     · de tintcode lezen (7/37 → diepte 7, reflecties 3 en 7)
     · daar een kleurchip uit rekenen, met assets/tint-colors.json als tabel
     · de rijen sorteren op diepte en groepskoppen ertussen zetten
     · filterchips en het zoekveld combineren
     · de aantallen bijhouden en in één keer naar de winkelwagen sturen

   De rijen staan al in de HTML; hier wordt niets bijgemaakt behalve de
   groepskoppen. Zonder JavaScript blijft de lijst dus leesbaar en werkt de
   gewone knop "In winkelwagen" met de gekozen tint. */

(function () {
  'use strict';

  /* Ingebouwde tabel. Hij staat hier zodat de chips meteen goed staan; het
     bestand tint-colors.json wordt daarna opgehaald en gaat er overheen, zodat
     kleuren bijgesteld kunnen worden zonder de code aan te raken. */
  var TABEL = {
    depths: {
      1: '#0c0b0a',
      2: '#1a1310',
      3: '#2b1d15',
      4: '#3e2a1c',
      5: '#563a26',
      6: '#6e4a2f',
      7: '#8a6039',
      8: '#a67c49',
      9: '#c39c66',
      10: '#d9bb8c',
      11: '#e5cda6',
      12: '#efe0c2'
    },
    tones: {
      0: null,
      1: '#5f6f7a',
      2: '#6b7a5c',
      3: '#c99228',
      4: '#b23f26',
      5: '#8d3a3c',
      6: '#7a4a8e',
      7: '#6a4a33',
      8: '#a6adb8',
      9: '#8b8d93'
    },
    mix: { primary: 0.32, secondary: 0.15, intense: 0.44 },
    fallback: '#b9b2a8',
    overrides: {}
  };

  /* Reflectie → filterchip. De namen komen uit de vertaalbestanden; hier staat
     alleen welke reflectie bij welke groep hoort. */
  var FAMILIES = {
    0: 'naturel',
    1: 'as',
    2: 'as',
    9: 'as',
    3: 'goud',
    4: 'rood',
    5: 'rood',
    6: 'violet',
    8: 'violet',
    7: 'bruin'
  };

  function hexNaarRgb(hex) {
    if (!hex) return null;
    var h = String(hex).replace('#', '').trim();
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    if (h.length !== 6) return null;
    var n = parseInt(h, 16);
    if (isNaN(n)) return null;
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }

  function rgbNaarHex(rgb) {
    return (
      '#' +
      rgb
        .map(function (v) {
          var x = Math.max(0, Math.min(255, Math.round(v))).toString(16);
          return x.length === 1 ? '0' + x : x;
        })
        .join('')
    );
  }

  function meng(basis, toon, deel) {
    if (!toon) return basis;
    return basis.map(function (v, i) {
      return v * (1 - deel) + toon[i] * deel;
    });
  }

  /* "7/37" → { diepte: 7, intens: false, reflecties: [3, 7] }
     "33/55" → { diepte: 3, intens: true, reflecties: [5, 5] }
     "4 - Bruin" → { diepte: 4, intens: false, reflecties: [0] }
     Punt en streepje tellen als schuine streep, zodat de Keune-notatie
     ("7.34") en de L'Oréal-notatie ("5-3") er ook doorheen komen. */
  function leesCode(code) {
    if (!code) return null;
    var schoon = String(code).trim().replace(/[.\-–]/g, '/');
    var delen = schoon.split('/');
    var diepteTekst = (delen[0] || '').replace(/[^0-9]/g, '');
    if (!diepteTekst) return null;
    var intens = diepteTekst.length === 2 && diepteTekst[0] === diepteTekst[1];
    var diepte = intens ? parseInt(diepteTekst[0], 10) : parseInt(diepteTekst, 10);
    var reflectieTekst = (delen[1] || '').replace(/[^0-9]/g, '');
    var reflecties = reflectieTekst
      ? reflectieTekst.split('').map(function (c) {
          return parseInt(c, 10);
        })
      : [0];
    return {
      diepte: diepte,
      diepteTekst: diepteTekst,
      intens: intens,
      reflecties: reflecties,
      hoofdreflectie: reflecties[0]
    };
  }

  /* Zet de kleur op het bolletje, of verbergt het als we de kleur niet kennen.
     De rij krijgt dan een modifier zodat de gridkolom van 28px dichtklapt en de
     tintnaam niet in die lege ruimte valt. */
  function zetChip(rij, chip, code) {
    if (!chip) return;
    var kleur = kleurVoor(code);
    if (kleur) {
      chip.style.backgroundColor = kleur;
      rij.classList.remove('tint-row--geen-chip');
    } else {
      chip.style.backgroundColor = '';
      rij.classList.add('tint-row--geen-chip');
    }
  }

  /* Geeft null terug als de code geen kleur prijsgeeft. De aanroeper verbergt
     het bolletje dan; een beige rondje bij "GEEL" of "Booster" suggereert een
     kleur die het niet is, en dat is misleidender dan geen bolletje. */
  function kleurVoor(code) {
    if (TABEL.overrides && TABEL.overrides[code]) return TABEL.overrides[code];
    var g = leesCode(code);
    if (!g) return null;
    /* De 0-reeks is Special Mix: puur pigment zonder eigen diepte. Zonder
       override laten we de reflectie zelf de kleur bepalen. Kent de tabel die
       reflectie niet, dan weten we het simpelweg niet. */
    var basisHex = TABEL.depths[g.diepte];
    if (g.diepte === 0) {
      basisHex = TABEL.tones[g.hoofdreflectie];
    }
    if (!basisHex) return null;
    var basis = hexNaarRgb(basisHex) || hexNaarRgb(TABEL.fallback);
    var deel = g.intens ? TABEL.mix.intense : TABEL.mix.primary;
    var eerste = hexNaarRgb(TABEL.tones[g.reflecties[0]]);
    if (eerste) basis = meng(basis, eerste, deel);
    if (g.reflecties.length > 1) {
      var tweede = hexNaarRgb(TABEL.tones[g.reflecties[1]]);
      if (tweede) basis = meng(basis, tweede, TABEL.mix.secondary);
    }
    return rgbNaarHex(basis);
  }

  function familieVan(code) {
    var g = leesCode(code);
    if (!g) return '';
    if (g.diepte === 0) return 'mix';
    if (g.diepte === 12) return 'special';
    return FAMILIES[g.hoofdreflectie] || '';
  }

  /* --------------------------------------------------------------- element */

  class HwsTintSelector extends HTMLElement {
    connectedCallback() {
      if (this.klaar) return;
      this.klaar = true;
      this.lijst = this.querySelector('[data-tint-list]');
      this.rijen = Array.prototype.slice.call(this.querySelectorAll('[data-tint-row]'));
      if (!this.lijst || !this.rijen.length) return;

      this.zoekveld = this.querySelector('[data-tint-search]');
      this.chips = Array.prototype.slice.call(this.querySelectorAll('[data-tint-filter]'));
      this.balk = this.querySelector('[data-tint-bar]');
      this.balkTekst = this.querySelector('[data-tint-bar-text]');
      this.balkKnop = this.querySelector('[data-tint-submit]');
      this.leegTekst = this.querySelector('[data-tint-empty]');
      this.foutTekst = this.querySelector('[data-tint-error]');
      this.formulier = this.getAttribute('data-form')
        ? document.getElementById(this.getAttribute('data-form'))
        : null;
      this.filter = '';

      this.verwerkRijen();
      this.sorteerEnGroepeer();
      this.koppelGebeurtenissen();
      this.werkBalkBij();
      this.haalTabelOp();
      this.meetBesturing();
      this.volgHeader();
    }

    /* De groepskoppen plakken onder de zoek- en filterbalk. Die hoogte stond als
       vaste 118px in de CSS, maar de balk is 123px en wordt hoger zodra de chips
       over twee regels vallen — de koppen doken dan achter de balk weg. Hier meten
       we hem echt op en geven we hem door als variabele. */
    /* De onderkant van de header zelf bijhouden.

       De balk plakte op --header-offset uit theme.js, en die waarde liep achter op
       de werkelijkheid: bovenaan de pagina is de header 163px, ga je scrollen dan
       klapt hij in tot 64px (de zoekbalk verdwijnt), en scrol je terug dan gaat hij
       weer naar 163px. Werd die wissel te laat doorgegeven, dan stond de balk nog
       op 64px terwijl de header al 163px was — de header lag dan over de bovenste
       99px van de balk heen en alleen de onderste rij tintfamilies was nog aan te
       klikken.

       Hier meten we de header rechtstreeks op, vlak voor het tekenen. Dat kan niet
       achterlopen. */
    volgHeader() {
      var header = document.querySelector('[data-sticky-header]');
      if (!header) return;
      var self = this;
      var vorige = -1;
      var gepland = false;
      var zet = function () {
        var onder = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
        if (onder === vorige) return;
        vorige = onder;
        self.style.setProperty('--tint-header-offset', onder + 'px');
      };
      var plan = function () {
        if (gepland) return;
        gepland = true;
        requestAnimationFrame(function () {
          gepland = false;
          zet();
        });
      };
      zet();
      window.addEventListener('scroll', plan, { passive: true });
      window.addEventListener('resize', plan, { passive: true });
      if (typeof ResizeObserver === 'function') {
        this.headerWaarnemer = new ResizeObserver(zet);
        this.headerWaarnemer.observe(header);
      }
    }

    meetBesturing() {
      var besturing = this.querySelector('.tint-selector__controls');
      if (!besturing) return;
      var self = this;
      var zet = function () {
        var h = Math.round(besturing.getBoundingClientRect().height);
        if (h > 0) self.style.setProperty('--tint-controls-height', h + 'px');
      };
      zet();
      if (typeof ResizeObserver === 'function') {
        /* De waarnemer moet bewaard blijven. Zonder verwijzing ernaartoe ruimt de
           browser hem op en vuurt hij nooit: de eerste meting bleef dan staan
           (123px), terwijl de balk bij negen tintfamilies over drie regels 193px
           wordt. De groepskoppen doken daardoor 70px te hoog achter de balk weg. */
        this.besturingWaarnemer = new ResizeObserver(zet);
        this.besturingWaarnemer.observe(besturing);
      }
      /* Ook bij een andere schermbreedte opnieuw meten — bij het draaien van een
         telefoon breken de tintfamilies over een ander aantal regels. */
      window.addEventListener('resize', zet, { passive: true });
    }

    /* Code lezen, kleur zetten en de zoek- en filterwaarden klaarzetten. */
    verwerkRijen() {
      this.rijen.forEach(function (rij) {
        var code = rij.getAttribute('data-tint-code') || '';
        var g = leesCode(code);
        rij.__tint = {
          code: code,
          groep: g ? g.diepte : 99,
          intens: g ? g.intens : false,
          reflectie: g ? g.hoofdreflectie : 99,
          familie: familieVan(code)
        };
        rij.setAttribute('data-tint-family', rij.__tint.familie);
        var chip = rij.querySelector('[data-tint-chip]');
        zetChip(rij, chip, code);
      });
    }

    /* Diepte oplopend, daarbinnen eerst de gewone tinten en dan de intense, en
       per diepte een kop. De Special Mix (0/xx) heeft geen diepte en gaat naar
       achteren; die staat in zijn eigen groep. */
    sorteerEnGroepeer() {
      var self = this;
      var gesorteerd = this.rijen.slice().sort(function (a, b) {
        var ga = a.__tint;
        var gb = b.__tint;
        var da = ga.groep === 0 ? 999 : ga.groep;
        var db = gb.groep === 0 ? 999 : gb.groep;
        if (da !== db) return da - db;
        if (ga.intens !== gb.intens) return ga.intens ? 1 : -1;
        if (ga.reflectie !== gb.reflectie) return ga.reflectie - gb.reflectie;
        return ga.code.localeCompare(gb.code, 'nl', { numeric: true });
      });

      var fragment = document.createDocumentFragment();
      var vorige = null;
      gesorteerd.forEach(function (rij) {
        var groep = rij.__tint.groep;
        if (groep !== vorige) {
          fragment.appendChild(self.maakKop(groep));
          vorige = groep;
        }
        fragment.appendChild(rij);
      });
      this.lijst.appendChild(fragment);
      this.rijen = gesorteerd;
    }

    maakKop(groep) {
      var li = document.createElement('li');
      li.className = 'tint-group';
      li.setAttribute('data-tint-group', String(groep));
      li.setAttribute('role', 'presentation');
      var namen = {};
      try {
        namen = JSON.parse(this.getAttribute('data-depth-names') || '{}');
      } catch (e) {
        namen = {};
      }
      var naam = namen[groep];
      li.textContent = naam ? groep + ' · ' + naam : String(groep);
      if (groep === 0) li.textContent = namen['0'] || 'Special Mix';
      return li;
    }

    koppelGebeurtenissen() {
      var self = this;

      if (this.zoekveld) {
        this.zoekveld.addEventListener('input', function () {
          self.pasFilterToe();
        });
      }

      this.chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          self.filter = chip.getAttribute('data-tint-filter') || '';
          self.chips.forEach(function (c) {
            var actief = c === chip;
            c.classList.toggle('hws-chip--active', actief);
            c.setAttribute('aria-pressed', actief ? 'true' : 'false');
          });
          self.pasFilterToe();
        });
      });

      /* Eén luisteraar voor alle rijen: bij 174 rijen scheelt dat honderden
         losse handlers. */
      this.lijst.addEventListener('click', function (event) {
        var min = event.target.closest('[data-tint-minus]');
        var plus = event.target.closest('[data-tint-plus]');
        var rij = event.target.closest('[data-tint-row]');
        if (!rij) return;
        if (min || plus) {
          event.preventDefault();
          self.zetAantal(rij, self.aantalVan(rij) + (plus ? 1 : -1));
          return;
        }
        if (event.target.closest('[data-tint-input]')) return;
        /* Tik op de rij zelf zet hem op 1. Eerder zette een tweede tik hem terug
           op 0, en omdat de hele rij klikvlak is — inclusief de bezorgregel die op
           een telefoon over de volle breedte staat — wiste één misser naast de
           stepper een ingevuld aantal van 4. Terugzetten doe je met de min-knop. */
        if (rij.getAttribute('data-tint-available') === 'false') return;
        if (self.aantalVan(rij) > 0) return;
        self.zetAantal(rij, 1);
      });

      this.lijst.addEventListener('change', function (event) {
        var veld = event.target.closest('[data-tint-input]');
        if (!veld) return;
        var rij = veld.closest('[data-tint-row]');
        self.zetAantal(rij, parseInt(veld.value, 10) || 0);
      });

      if (this.balkKnop) {
        this.balkKnop.addEventListener('click', function () {
          self.inWinkelwagen();
        });
      }
    }

    aantalVan(rij) {
      var veld = rij.querySelector('[data-tint-input]');
      return veld ? parseInt(veld.value, 10) || 0 : 0;
    }

    zetAantal(rij, waarde) {
      if (!rij) return;
      if (rij.getAttribute('data-tint-available') === 'false') waarde = 0;
      var veld = rij.querySelector('[data-tint-input]');
      var nieuw = Math.max(0, waarde);
      if (veld) veld.value = nieuw;
      rij.classList.toggle('is-chosen', nieuw > 0);
      /* De gewone koopknop hoort bij de laatst aangeraakte tint, zodat die knop
         niet iets anders in de winkelwagen legt dan de klant hier aanklikt. */
      if (nieuw > 0) this.zetFormulierVariant(rij.getAttribute('data-tint-id'), rij);
      this.werkBalkBij();
    }

    /* De koopkolom (prijs, voorraad, bezorgregel, koopknop) luistert naar
       hws:variant:change en heeft daarvoor een variant-object met een url nodig;
       met alleen een id stapte hij er meteen weer uit en bleef de kolom op de
       eerste tint staan. */
    zetFormulierVariant(id, rij) {
      if (!id) return;
      if (this.formulier) {
        var veld = this.formulier.querySelector('[name="id"]');
        if (veld) veld.value = id;
      }
      var pad = this.getAttribute('data-url') || window.location.pathname;
      document.dispatchEvent(
        new CustomEvent('hws:variant:change', {
          detail: {
            variant: {
              id: Number(id),
              url: pad.split('?')[0] + '?variant=' + id,
              code: rij ? rij.getAttribute('data-tint-code') : '',
              available: rij ? rij.getAttribute('data-tint-available') !== 'false' : true
            },
            sectionId: this.getAttribute('data-section'),
            source: 'tint-selector'
          }
        })
      );
      if (this.hasAttribute('data-update-url') && window.history && window.history.replaceState) {
        window.history.replaceState({}, '', pad.split('?')[0] + '?variant=' + id);
      }
    }

    gekozen() {
      var uit = [];
      this.rijen.forEach(function (rij) {
        var veld = rij.querySelector('[data-tint-input]');
        var aantal = veld ? parseInt(veld.value, 10) || 0 : 0;
        if (aantal > 0) {
          uit.push({
            id: Number(rij.getAttribute('data-tint-id')),
            aantal: aantal,
            prijs: Number(rij.getAttribute('data-tint-price')) || 0
          });
        }
      });
      return uit;
    }

    werkBalkBij() {
      if (!this.balk) return;
      var keuze = this.gekozen();
      var tinten = keuze.length;
      var totaal = keuze.reduce(function (som, r) {
        return som + r.prijs * r.aantal;
      }, 0);
      this.balk.hidden = tinten === 0;
      if (this.balkKnop) this.balkKnop.disabled = tinten === 0;

      /* De koopbalk van de productpagina plakt óók onderaan en ligt met z-index
         30 over deze balk heen: je klikte dan op de verkeerde knop of op niets.
         Zolang er tinten gekozen zijn nemen we die balk weg — de knop hier is
         dan de juiste, want die legt álle gekozen tinten in de winkelwagen. */
      var koopbalk = document.querySelector('[data-product-sticky-bar]');
      if (koopbalk) {
        if (tinten > 0) {
          koopbalk.setAttribute('data-tint-onderdrukt', '');
        } else {
          koopbalk.removeAttribute('data-tint-onderdrukt');
        }
      }
      if (this.balkTekst) {
        var sjabloon = tinten === 1
          ? this.getAttribute('data-label-one')
          : this.getAttribute('data-label-many');
        this.balkTekst.textContent = (sjabloon || '')
          .replace('%n', String(tinten))
          .replace('%s', this.geld(totaal));
      }
    }

    geld(centen) {
      var opmaak = this.getAttribute('data-money') || '€%s';
      var bedrag = (centen / 100).toFixed(2).replace('.', ',');
      return opmaak.indexOf('%s') === -1 ? opmaak + bedrag : opmaak.replace('%s', bedrag);
    }

    pasFilterToe() {
      var term = (this.zoekveld && this.zoekveld.value ? this.zoekveld.value : '')
        .toLowerCase()
        .trim();
      var filter = this.filter;
      var zichtbaar = 0;
      this.rijen.forEach(function (rij) {
        var past = true;
        if (filter && rij.__tint.familie !== filter) past = false;
        if (past && term) {
          var zoek = rij.getAttribute('data-tint-search') || '';
          if (zoek.indexOf(term) === -1) past = false;
        }
        rij.hidden = !past;
        if (past) zichtbaar += 1;
      });

      /* Een groepskop zonder zichtbare rijen eronder mag ook weg. */
      var koppen = this.lijst.querySelectorAll('[data-tint-group]');
      Array.prototype.forEach.call(koppen, function (kop) {
        var leeg = true;
        var volgende = kop.nextElementSibling;
        while (volgende && !volgende.hasAttribute('data-tint-group')) {
          if (!volgende.hidden) {
            leeg = false;
            break;
          }
          volgende = volgende.nextElementSibling;
        }
        kop.hidden = leeg;
      });

      if (this.leegTekst) this.leegTekst.hidden = zichtbaar > 0;
    }

    /* Toevoegen loopt via de winkelwagen van het thema (window.hwsCart), niet via
       een eigen fetch. Dat was de reden dat er "niks gebeurde": de tinten kwamen
       wél in de winkelwagen, maar het aantal in de header werd niet bijgewerkt,
       de lade ging niet open en de winkelwagensecties werden niet opnieuw
       gerenderd — precies wat je van een klik verwacht te zien. */
    inWinkelwagen() {
      var self = this;
      var keuze = this.gekozen();
      if (!keuze.length) return;
      if (this.foutTekst) this.foutTekst.hidden = true;
      this.balkKnop.classList.add('btn--loading');
      this.balkKnop.setAttribute('aria-busy', 'true');
      this.balkKnop.disabled = true;

      var items = keuze.map(function (r) {
        return { id: r.id, quantity: r.aantal };
      });

      var klaar = function () {
        self.balkKnop.classList.remove('btn--loading');
        self.balkKnop.removeAttribute('aria-busy');
        self.werkBalkBij();
      };

      var mislukt = function (bericht) {
        if (self.foutTekst) {
          self.foutTekst.textContent = bericht || self.getAttribute('data-label-error') || '';
          self.foutTekst.hidden = false;
        }
        if (window.hwsAnnounce) window.hwsAnnounce(bericht || '');
        klaar();
      };

      var gelukt = function (res) {
        self.rijen.forEach(function (rij) {
          self.zetAantal(rij, 0);
        });
        if (window.hwsCart) {
          if (res) window.hwsCart.renderSections(res);
          window.hwsCart.fetchState().then(function (state) {
            window.hwsCart.syncCount(state);
          });
        }
        var config = window.hwsSettings || {};
        if (config.cartType === 'drawer' && document.getElementById('CartDrawer') && window.hwsOverlay) {
          window.hwsOverlay.open('CartDrawer');
        } else if (window.hwsToast) {
          window.hwsToast.show((window.hwsStrings || {}).addedToCart || '');
        }
        klaar();
      };

      if (window.hwsCart && window.hwsCart.add) {
        window.hwsCart
          .add(items)
          .then(function (res) {
            if (res && (res.__error || res.status)) {
              mislukt(res.description || res.message);
              return;
            }
            gelukt(res);
          })
          .catch(function () {
            mislukt();
          });
        return;
      }

      /* Terugval als theme.js (nog) niet geladen is. */
      fetch(this.getAttribute('data-cart-add') || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw new Error(data.description || data.message || '');
            return data;
          });
        })
        .then(function () {
          gelukt(null);
        })
        .catch(function (error) {
          mislukt(error.message);
        });
    }

    /* De kleurtabel uit assets/tint-colors.json gaat over de ingebouwde heen.
       Lukt dat niet, dan blijven de chips staan zoals ze al zijn. */
    haalTabelOp() {
      var bron = this.getAttribute('data-colors');
      if (!bron || HwsTintSelector.tabelGeladen) return;
      HwsTintSelector.tabelGeladen = true;
      var self = this;
      fetch(bron)
        .then(function (response) {
          if (!response.ok) throw new Error('geen tabel');
          return response.json();
        })
        .then(function (data) {
          if (data.depths) TABEL.depths = data.depths;
          if (data.tones) TABEL.tones = data.tones;
          if (data.mix) TABEL.mix = data.mix;
          if (data.fallback) TABEL.fallback = data.fallback;
          if (data.overrides) TABEL.overrides = data.overrides;
          document.querySelectorAll('[data-tint-row]').forEach(function (rij) {
            var chip = rij.querySelector('[data-tint-chip]');
            zetChip(rij, chip, rij.getAttribute('data-tint-code'));
          });
          self.dispatchEvent(new CustomEvent('hws:tint:colors'));
        })
        .catch(function () {
          /* stil: de ingebouwde tabel staat er al */
        });
    }
  }

  if (!customElements.get('hws-tint-selector')) {
    customElements.define('hws-tint-selector', HwsTintSelector);
  }
})();
